(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8420,1674],{

/***/ 816893:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/404",
      function () {
        return __webpack_require__(655018);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 692687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _404Page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/utils/themeImports.js + 1 modules
var themeImports = __webpack_require__(353978);
// EXTERNAL MODULE: ./src/utils/specificThemeRender.ts
var specificThemeRender = __webpack_require__(698616);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(268037);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
;// CONCATENATED MODULE: ./src/assets/svgExports/SearchIcon404.js


var SearchIcon404 = function(param) {
    var height = param.height, width = param.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        viewBox: "0 0 201 200",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                fillRule: "evenodd",
                d: "m132.534 99.053-33.146 33.144s11.787-3.681 28.728 2.209c2.85.991 7.618-3.778 6.628-6.628-5.891-16.94-2.21-28.725-2.21-28.725",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#F7F7F7",
                fillRule: "evenodd",
                d: "M43.825 43.488c20.125-20.122 52.797-20.122 72.922 0 20.122 20.124 20.122 52.796 0 72.921-20.125 20.122-52.797 20.122-72.922 0-20.122-20.125-20.122-52.797 0-72.922",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#E9E9E9",
                fillRule: "evenodd",
                d: "M110.081 37.856a52 52 0 0 1 6.666 5.631c20.122 20.125 20.122 52.797 0 72.922-20.125 20.122-52.797 20.122-72.922 0a53 53 0 0 1-3.347-3.681c19.506 6.338 41.8 1.763 57.288-13.725 16.518-16.519 20.625-40.781 12.315-61.147",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#BABABA",
                fillRule: "evenodd",
                d: "M39.406 39.069c22.563-22.563 59.197-22.563 81.76 0 22.562 22.562 22.562 59.197 0 81.759-22.563 22.563-59.197 22.563-81.76 0-22.562-22.562-22.562-59.197 0-81.76m6.628 6.628c18.904-18.903 49.6-18.903 68.504 0 18.903 18.903 18.903 49.6 0 68.503-18.904 18.903-49.6 18.903-68.504 0-18.903-18.903-18.903-49.6 0-68.503",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#BABABA",
                fillRule: "evenodd",
                d: "M28.49 105.656c-10.724-21.622-7.087-48.584 10.916-66.587 16.907-16.906 41.713-21.144 62.585-12.713a74.5 74.5 0 0 1 .09 10.325c-18.16-9.143-40.89-6.137-56.047 9.016-16.065 16.066-18.478 40.65-7.23 59.275-3.295.45-6.657.684-10.07.684z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                fillRule: "evenodd",
                d: "M125.584 145.134c-5.49-5.49-5.49-14.393 0-19.887 5.491-5.491 14.397-5.491 19.888 0l45.3 45.3c1.219 1.219-2.247 6.666-7.734 12.153-5.488 5.488-10.935 8.953-12.154 7.734z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#E9E9E9",
                fillRule: "evenodd",
                d: "M125.584 145.134c-5.49-5.49-5.49-14.393 0-19.887 5.491-5.491 14.397-5.491 19.888 0l41 41c1.219 1.219-2.247 6.666-7.734 12.153-5.488 5.488-10.935 8.953-12.154 7.734z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                fillRule: "evenodd",
                d: "M73.666 70.11c-.072-2.979 1.047-5.154 2.772-6.429 2.712-2 6.765-1.915 8.965.563.944 1.065 1.49 2.572 1.506 4.478.038 4.572-2.106 7.244-4.206 10.01-2.825 3.727-5.647 7.559-5.997 13.956a3.127 3.127 0 0 0 6.244.34c.263-4.86 2.587-7.69 4.734-10.522 2.875-3.79 5.529-7.572 5.475-13.834-.03-3.681-1.259-6.522-3.084-8.578-4.263-4.8-12.09-5.319-17.347-1.444-3.15 2.325-5.44 6.175-5.312 11.606a3.127 3.127 0 0 0 6.25-.147",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                d: "M79.538 107.584a3.844 3.844 0 1 0 0-7.687 3.844 3.844 0 0 0 0 7.687"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                fillRule: "evenodd",
                d: "m135.775 26.553 9.375-15.625a3.124 3.124 0 1 0-5.359-3.216l-9.375 15.625a3.125 3.125 0 1 0 5.359 3.216M150.559 36.85l34.375-25a3.13 3.13 0 0 0 .691-4.366 3.13 3.13 0 0 0-4.366-.69l-34.375 25a3.127 3.127 0 0 0 3.675 5.056M155.728 56.103l25-6.25a3.126 3.126 0 1 0-1.515-6.062l-25 6.25a3.124 3.124 0 0 0 1.515 6.063",
                clipRule: "evenodd"
            })
        ]
    });
};
/* harmony default export */ var svgExports_SearchIcon404 = (SearchIcon404);

// EXTERNAL MODULE: ./src/utils/getWindowDimension.js
var getWindowDimension = __webpack_require__(37110);
// EXTERNAL MODULE: ./src/utils/handleRedirectToHomePage.js
var handleRedirectToHomePage = __webpack_require__(254051);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
;// CONCATENATED MODULE: ./src/containers/404Page/ErrorMsg.tsx







var ErrorMsg = function() {
    var store = (0,es/* useSelector */.v9)(function(state) {
        return {
            store: state.storeReducer.store
        };
    }).store;
    var isDesktop = (0,getWindowDimension/* default */.Z)().isDesktop;
    var ref = function() {
        var size = isDesktop ? 200 : 100;
        return {
            height: size,
            width: size
        };
    }(), height = ref.height, width = ref.width;
    var goToHomePage = function() {
        (0,handleRedirectToHomePage/* redirectToHomePage */.A)(routes.PATH.PRODUCT, store === null || store === void 0 ? void 0 : store.domain);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-static tw-flex tw-flex-col tw-bg-white ".concat(isDesktop ? "tw-my-[78px] tw-gap-[60px]" : "tw-my-[138px] tw-gap-[48px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-items-center ".concat(isDesktop ? "tw-gap-[40px]" : "tw-gap-[32px]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svgExports_SearchIcon404, {
                        height: height,
                        width: width
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "msg tw-flex tw-flex-col tw-gap-16 tw-text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-font-inter tw-text-[22px]/[32px] tw-font-semibold tw-text-[#000000] md:tw-text-[32px]/[44px] md:tw-font-semibold",
                                children: "Uh oh, this page does not exist."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "tw-font-inter tw-text-[14px] tw-font-normal tw-leading-[22px] tw-text-[#00000099] md:tw-text-[18px]/7",
                                children: [
                                    "You may have mistyped the address or the ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " page may have been removed."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-flex tw-justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: goToHomePage,
                    className: "tw-mx-auto tw-w-[90%] tw-cursor-pointer tw-rounded-lg tw-border-none tw-bg-[#2B74D8] tw-px-24 tw-py-10 tw-font-inter tw-text-[14px] tw-font-semibold tw-leading-8 tw-text-white md:tw-w-auto md:tw-text-[16px]",
                    children: "Go to home page"
                })
            })
        ]
    });
};
/* harmony default export */ var _404Page_ErrorMsg = (ErrorMsg);

// EXTERNAL MODULE: ./src/utils/ssrCommonApiCall.ts + 1 modules
var ssrCommonApiCall = __webpack_require__(122987);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
;// CONCATENATED MODULE: ./src/containers/404Page/index.tsx









var Error404 = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var dispatch = (0,es/* useDispatch */.I0)();
    var storeInfo = (0,redux/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    (0,react.useEffect)(function() {
        (0,ssrCommonApiCall/* ssrDataCall */.z)([
            "collections",
            "categories",
            "seo"
        ], storeInfo).then(function(data) {
            dispatch((0,catalog/* saveCatalogCategories */.FF)((data === null || data === void 0 ? void 0 : data.catalogCategories) || []));
            dispatch((0,catalog/* saveCollections */.VN)((data === null || data === void 0 ? void 0 : data.collections) || []));
            dispatch((0,catalog/* saveCatalogTags */.Vj)((data === null || data === void 0 ? void 0 : data.catalogTags) || []));
        });
    }, [
        storeInfo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "ErrorPage_wrapper",
        children: [
            (ref = (0,specificThemeRender/* specificThemeRender */.t)(storeInfo)) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Header) === null || ref2 === void 0 ? void 0 : ref2.map(function(layout) {
                return (0,themeImports/* getThemeComponent */.s)(layout.sub_type, layout.name, layout);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(_404Page_ErrorMsg, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "EroorPage_body_wrapper",
                children: (ref3 = (0,specificThemeRender/* specificThemeRender */.t)(storeInfo)) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.components) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Footer) === null || ref5 === void 0 ? void 0 : ref5.map(function(layout) {
                    return (0,themeImports/* getThemeComponent */.s)(layout.sub_type, layout.name, layout);
                })
            })
        ]
    });
};
/* harmony default export */ var _404Page = (Error404);


/***/ }),

/***/ 655018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(117321);
/* harmony import */ var _containers_404Page_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(692687);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(225617);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);






var ErrorPage = function() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var domainName = router.query.domain;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (domainName) {
            dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_5__/* .fetchStoreInfoBySubDomain */ .rf)(domainName));
        }
    }, [
        domainName
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_404Page_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ErrorPage);


/***/ }),

/***/ 254051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ redirectToHomePage; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(540190);


var redirectToHomePage = function(path, domain) {
    next_router__WEBPACK_IMPORTED_MODULE_0___default().push((0,_routes__WEBPACK_IMPORTED_MODULE_1__.getRoute)(path, domain));
};


/***/ }),

/***/ 698616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ specificThemeRender; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17247);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(186812);
/* harmony import */ var src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(423653);



var specificThemeRender = function(storeData) {
    var isSubscriptionDemoPreview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var mainTheme = (storeData === null || storeData === void 0 ? void 0 : storeData.theme) || {};
    var alternateTheme = (storeData === null || storeData === void 0 ? void 0 : storeData.store_premium_theme) || {};
    var isPremium = storeData === null || storeData === void 0 ? void 0 : storeData.premium;
    if (isSubscriptionDemoPreview || storeData.internal_admin_access === 1 || (storeData === null || storeData === void 0 ? void 0 : storeData.new_subscription_status) !== src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__/* .NEW_SUBSCRIPTIONS_STATUS.INACTIVE */ .W0.INACTIVE) return mainTheme;
    var toggleMobileView = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().commonReducer.toggleMobileView;
    if (_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__/* .deviceWidth */ .o > 998) {
        return isPremium || (mainTheme === null || mainTheme === void 0 ? void 0 : mainTheme.is_demo) === 1 || (mainTheme === null || mainTheme === void 0 ? void 0 : mainTheme.brand_website_flag) > 0 ? mainTheme : toggleMobileView ? mainTheme : alternateTheme;
    }
    return mainTheme;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8388,1562,1033,3978,9774,2888,179], function() { return __webpack_exec__(816893); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);